import { Inject, Injectable } from '@angular/core';
import { map, catchError } from 'rxjs/operators';
import { LoginService } from 'src/app/pages/login/services/login.service';
import { FiltroFirma, Filtros } from '../../../shared/models/filtros';
import { Firmas } from '../models/firmas';
import { ResumenFirmas } from '../models/resumen-firmas';
import * as fileSaver from 'file-saver';
import { ColDef } from 'ag-grid-community';
import { Observable, of, throwError } from 'rxjs';
import { GridColDefsData } from '../models/grid-col-defs-data';
import { MatSnackBar } from '@angular/material/snack-bar';
import { ResumenEventos } from '../models/resumen-eventos';
import { EstadosFirmaService } from './estados-firma.service';
import { IGestionarFirmasService } from './ports/i-gestionar-firmas-service';
import { Documento } from '../models/documento';
import { TipoDocumento } from '../../configuracion/Envios/documentos/models/tipo-documento';
import { RecuperaConfiguracionAplicacionApiService } from '../../configuracion/configuracion-rlt/services/recupera-configuracion-aplicacion-api.service';
import { Router } from '@angular/router';
import { ModificarArraysService } from 'src/app/shared/services/modificar-arrays.service';
import { FiltroSqp } from 'src/app/shared/components/sqp-components/sqpFiltroSuperior/models/filtro-sqp';
import { TipoFiltro } from 'src/app/shared/components/sqp-components/sqpFiltroSuperior/models/tipo-filtro';
import { OrdenColumna } from 'src/app/shared/models/orden-columna';
import { ResumenEstados, ResumenInicial } from '../models/resumen-inicial';
import { FormulariosInfo145, FormulariosInfo145Response } from '../models/formulariosInfo145';
import { GetFirmasPageResult } from '../models/get-firmas-page-result';

@Injectable({
  providedIn: 'root'
})
export class DatosFirmaService {

  firmas: Firmas[] = [];
  firmasFiltradas: Firmas[] = [];
  filtros: Filtros[] = [];
  firmasNuevas: Firmas[] = [];
  filtrosNuevos: FiltroFirma[] = [];
  resumenFirmas: ResumenFirmas[] = [];
  resumenEstados: ResumenEstados[] = [];
  desplegablesFiltros: any;
  actualizarDesplegables: boolean = false;

  public cargandoDatos: boolean = false;

  columnDefs: ColDef[] = new GridColDefsData().columDefs;

  private recuperandoExtra: boolean = false;
  private abort: AbortController = new AbortController();

  refreshFirmas: boolean;
  resumenInicial: ResumenInicial;

  constructor(private loginService: LoginService,
    private estadosFirma: EstadosFirmaService,
    private _snackBar: MatSnackBar,
    @Inject('GestionaFirmas') private datosFirmas: IGestionarFirmasService,
    public recuperaConfiguracionAplicacionService: RecuperaConfiguracionAplicacionApiService,
    private router: Router,
    private modificarArraysService: ModificarArraysService) { }

  // Recuperar todas las firmas registradas en base de datos
  GetFirmas(filtrosFirmas: FiltroSqp[], pageNumber: number, pageSize: number = 50, orden: OrdenColumna = { campoOrden: '', orden: '' }, refresh?: boolean): Observable<GetFirmasPageResult> {
    this.firmasFiltradas = []; //para que al mostrar las firmas nuevas en la pastilla de los filtros se muestre como 0 cuando se esté cargando
    if (this.recuperandoExtra) this.abort.abort();
    this.cargandoDatos = true;
    return this.datosFirmas.GetFirmas(filtrosFirmas, pageNumber, pageSize, orden).pipe(
      map((response: GetFirmasPageResult) => {
        const firmas = response.data ?? [];
        firmas.forEach(x => {
          if (x.fechaCreacion != null) x.fechaCreacion = new Date(x.fechaCreacion);
          if (x.fechaEnvio != null) x.fechaEnvio = new Date(x.fechaEnvio);
          if (x.fechaFirma != null) x.fechaFirma = new Date(x.fechaFirma);
          x.fechaUltimaActualizacion = new Date(x.fechaUltimaActualizacion);
          if (x.fechaContrato != null) x.fechaContrato = new Date(new Date(x.fechaContrato).setHours(12, 0, 0, 0));
          x.cargaCompleatada = false;
        });
        this.firmas = firmas;
        this.firmasFiltradas = firmas;

        this.cargandoDatos = false;
        this.refreshFirmas = false;
        return {
          data: firmas,
          hasMore: response.hasMore,
          pageNumber: response.pageNumber
        };
      }),
      catchError(error => {
        console.error('error getFirmas: ', error);
        this.cargandoDatos = false;
        if (error.status == 401) {
          this.firmas = [];
          return of({ data: [], hasMore: false, pageNumber });
        } else {
          throw error;
        }
      })
    );
  }

  async GetDatosExtraFirmas(signal: AbortSignal) {
    try {
      this.recuperandoExtra = true;
      const max = this.firmas.length;
      for (let i = this.firmas.length - 1; i >= 0; i--) {
        const firma = this.firmas[i];
        if (signal.aborted) {
          this.abort = new AbortController();
          return;
        }
        // await this.GetDatosExtraFirmaCall(i);

        let documentosSubidosString: string = '';
        let documentosPendientesString: string = '';
        if (firma.documentos) {
          firma.documentos.forEach((doc: Documento, index: number) => {
            documentosSubidosString += (index != (firma.documentos.length - 1)) ? `${doc.nombreDocumento}, ` : `${doc.nombreDocumento}`;
          });
          if (['Pendiente', 'Error'].includes(firma.estadoString) && (firma.docNecesarios != firma.documentos?.length) && firma.tiposDocumento) {
            // Con los documentos no fusionables no hay problema, pero con los que lo son solo obtenemos el tipo de documento del primero, del resto (los que se han unido al primero) no.
            let idTiposDocumentoDocumentosSubidos: number[] = firma.documentos?.map((x: Documento) => x.tipoDocumento.idTipoDocumento);
            let tiposDocumentoPendientes: TipoDocumento[] = firma.tiposDocumento.filter((tipoDoc: TipoDocumento) => !tipoDoc.generico && !idTiposDocumentoDocumentosSubidos.includes(tipoDoc.idTipoDocumento));
            let tiposDocumentoPendientesFusionables = tiposDocumentoPendientes.filter(y => y.fusionable).map(y => y.nombre);
            let tiposDocumentoPendientesNoFusionables = tiposDocumentoPendientes.filter(y => !y.fusionable).map(y => y.nombre);
            if (tiposDocumentoPendientesNoFusionables.length > 0) documentosPendientesString += `No fusionables: ${tiposDocumentoPendientesNoFusionables.join(',')}`;
            if (tiposDocumentoPendientesFusionables.length > 0) documentosPendientesString += ` Fusionables: ${tiposDocumentoPendientesFusionables.join(',')}`;

          }
        }
        firma.documentosSubidosString = documentosSubidosString;
        firma.documentosPendientesString = documentosPendientesString;
      }

      this.recuperandoExtra = false;
    } catch (e: any) {
      if (e.name !== 'AbortError') throw e;
    }
  }

  async GetDatosExtraFirmaCall(index: number) {
    if (!this.firmas[index].cargaCompleatada) {

      //CARGAMOS LOS DOCUMETNOS
      await this.datosFirmas.GetInfoDocs(index).pipe(
        map((response: any) => {
          this.firmas[index].documentos = response
        })
      ).toPromise();

      //Cargamos los eventos
      this.firmas[index].eventos = [];
      await this.datosFirmas.GetInfoEventos(index).pipe(
        map((response: any) => {
          const data: any[] = response
          data.forEach((element: any) => {
            this.firmas[index].eventos.push(new ResumenEventos(element));
          });
        })).toPromise();
      //Cargamos los TIPOS DE DOCUMENTO
      await this.datosFirmas.GetInfoTipoDocs(index).pipe(
        map((response: any) => {
          this.firmas[index].tiposDocumento = response
        })).toPromise();

      this.firmas[index].cargaCompleatada = true;
    }
  }

  // Aislamos las firmas nuevas
  GetNuevasFirmas(): Firmas[] {
    let fechaUltimaConexion = new Date(this.loginService.getUserLocalStorage().FechaUltimaConexion ?? '') ?? new Date();
    fechaUltimaConexion.setHours(fechaUltimaConexion.getUTCHours());
    let firmasNuevas = this.firmas.filter(x => new Date(x.fechaUltimaActualizacion) > new Date(fechaUltimaConexion));
    firmasNuevas.forEach(x => x.esNueva = true);
    return firmasNuevas;
  }

  // Borramos la lista de firmas seleccionadas

  BorrarFirmas(ids: number[]) {
    return this.datosFirmas.BorrarFirmas(ids).pipe(
      map((response: any) => {
        if (response) return response;
        // else throw new Error("Error al eliminar las firmas");
      }),
      catchError(this.handleErrorFirma));
  }

  // Borramos la firma seleccionada

  BorrarFirma(idFirma: number) {
    return this.datosFirmas.BorrarFirma(idFirma).pipe(
      map((response: any) => {
        if (response) return response;
        // else throw new Error("Error al eliminar la firma");
      }),
      catchError(this.handleErrorFirma));
  }

  // Cancelamos la firmas seleccionada

  CancelarFirma(idFirma: number) {
    return this.datosFirmas.CancelarFirma(idFirma).pipe(
      map((response: any) => {
        if (response) return response;
        // else throw new Error(`No se ha podido cancelar la firma por un error interno de Signaturit: ${response.Message}`);
      }),
      catchError(this.handleErrorFirma));
  }

  // Genera la descarga de un envío firmado o parcialmente firmado
  descargandoFirmas: boolean = false;
  DescargaFirmaCompleta(id: any): void {
    this.descargandoFirmas = true;
    this.datosFirmas.DescargaFirmaCompleta(id).pipe(
      map((response: any) => {
        // Recuperamos el fichero en formato base64 string y obtenemos el array de bytes
        const byteCharacters = response
        const byteNumbers = new Array(byteCharacters.length);
        for (let i = 0; i < byteCharacters.length; i++) {
          byteNumbers[i] = byteCharacters.charCodeAt(i);
        }
        const byteArray = new Uint8Array(byteNumbers);
        return byteArray;
      })).subscribe(
        (ok: any) => {
          const blob = new Blob([ok], { type: "application/zip" });
          let fecha = new Date();
          let fileName = `Hire&Sign_${fecha.getFullYear()}${fecha.getMonth() + 1}${fecha.getDate()}${fecha.getHours()}${fecha.getMinutes()}${fecha.getSeconds()}.zip`;
          fileSaver.saveAs(blob, fileName);
          this.descargandoFirmas = false;
        },
        (error: any) => {
          console.error(error.message);
          if (error.message.endsWith('descargar')) {
            if (error.status !== 401) this._snackBar.open(error.message, 'Cerrar', { duration: 4000 });
          } else {
            this._snackBar.open('Se ha producido un error ' + error.message, 'Cerrar', { duration: 3000 });
          }
          this.descargandoFirmas = false;
        }
      );
  }
  //#endregion

  GetIconoName(estado: string): string {
    const valor = this.estadosFirma.ESTADOS_FIRMAS.find(x => x.estado == estado);
    if (valor) {
      return valor.icono;
    } else {
      return '';
    }
  }

  //Funcion que avisa cuando hayamos terminado de cargar los datos
  async FinCarga(): Promise<boolean> {
    return new Promise(
      (resolve) => {
        if (!this.cargandoDatos) {
          resolve(true);
        } else {
          setTimeout(() => {
            this.FinCarga().then(resp => resolve(true));
          }, 10)
        }
      }
    );
  }

  private handleErrorFirma(error: any) {
    let errorMessage = "";
    if (error.error instanceof ErrorEvent) {
      // A client-side or network error occurred. Handle it accordingly.
      errorMessage = `Error en el cliente : ${error.statusText}`;
    } else {
      // The backend returned an unsuccessful response code.
      // The response body may contain clues as to what went wrong.
      switch (error.status) {
        case 401:
          errorMessage = "Código de Clinte W.k. no váido";
          break;
        default:
          errorMessage = `Error en el Serviodor (${error.status}): ${error.statusText}`;
      }
    }
    return throwError(errorMessage);
  }

  filtrosConEstado: FiltroFirma[] = [];


  montarFiltroFechaEnvio(): FiltroSqp {
    let filtroFechaEnvio: FiltroSqp;
    const today = new Date();
    const tomorrow = new Date();
    tomorrow.setDate(tomorrow.getDate() + 1);
    const lastYear = new Date();
    lastYear.setFullYear(today.getFullYear() - 1);
    filtroFechaEnvio = {
      tipoFiltro: TipoFiltro.FECHA,
      titulo: 'Fecha de envío',
      valoresSeleccionados: {
        valorFechaDesde: this.getMedianoche(lastYear),
        valorFechaHasta: this.getMedianoche(tomorrow)
      }
    }
    return filtroFechaEnvio
  }

  getMedianoche(fecha: Date): Date {
    return new Date(fecha.getFullYear(), fecha.getMonth(), fecha.getDate(), 0, 0, 0);
  }

  cargaResumenHome(filtrosSqp: FiltroSqp[]) {
    return this.datosFirmas.cargarResumenHome(filtrosSqp).pipe(
      map((response: any) => {
        this.resumenInicial = response;
        const ordered = this.modificarArraysService.ordenarResumenEstados([...(response.ResumenEstados ?? [])]);
        this.resumenInicial.ResumenEstados = ordered;
        return this.resumenInicial;
      }),
      catchError((error: any) => {
        console.error('Error en cargaResumenHome:', error);
        return throwError(error);
      })
    );
  }

  getResumenEstados(filtrosSqp: FiltroSqp[]) {
    return this.datosFirmas.getResumenEstados(filtrosSqp).pipe(
      map((response: ResumenEstados[]) => {
        const ordered = this.modificarArraysService.ordenarResumenEstados([...(response ?? [])]);
        this.resumenEstados = ordered;
        return ordered;
      }),
      catchError((error: any) => {
        console.error(error);
        return throwError(error);
      })
    );
  }

  getDesplegablesFiltros(): Observable<any> {
    if (this.desplegablesFiltros && !this.actualizarDesplegables) {
      return of(this.desplegablesFiltros);
    } else {
      return this.datosFirmas.getDesplegablesFiltros().pipe(
        map((response: any) => {
          this.desplegablesFiltros = response;
          this.actualizarDesplegables = false;
          return this.desplegablesFiltros;
        }),
        catchError((error: any) => {
          console.error(error);
          return throwError(error);
        })
      );
    }
  }

  getDatosFormularios(filtrosFirmas: FiltroSqp[]): Observable<any> {
    return this.datosFirmas.getDatosFormularios(filtrosFirmas).pipe(
      map((response: any) => {
        return response;
      }),
      catchError((error: any) => {
        console.error(error);
        return throwError(error);
      })
    );
  }

  getFormulariosExcel(filtrosFirmas: FiltroSqp[], objetoFormularios: FormulariosInfo145[]): Observable<FormulariosInfo145Response[]> {
    return this.datosFirmas.getFormulariosExcel(filtrosFirmas, objetoFormularios).pipe(
      map((response: FormulariosInfo145Response[]) => {
        return response;
      }),
      catchError((error: any) => {
        console.error(error);
        return throwError(error);
      })
    );
  }
}

// const fileName = `Hire&Sign_datos_formularios_${new Date()
//   .toISOString()
//   .replace(/[:.-]/g, '')}.xlsx`;
// fileSaver.saveAs(blob, fileName);
